/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import BlockAccessPage from '../../../components/BlockAccess/BlockAccessPage';
import Loader from '../../../components/Loader/Loader';
import {API_ENDPOINT_JSON} from '../../../config';
import {
  blockAccessTypes,
  blockModelMessages,
  blockModelTypes
} from '../../../constants/blockPageConstatnts';
import {APITypeEnum} from '../../../services/interface/tableAPIType';
import countryJSON from '../../../services/modules/JSON/country';
import statesJSON from '../../../services/modules/JSON/statesJSON';
import nzmAPI from '../../../services/modules/NZM/NZMAPI';
import facilityDetailsAPI from '../../../services/modules/OM/facilityDetails';
import {accessModule} from '../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../utils/commonFunctions';
// import {yearSelect} from '../../../utils/FormUtils/yearSelect';
import {shouldBlockModuleAccess} from '../../../utils/SubscriptionHelper';
import YearAndCountryFilter from '../components/YearAndCountryFilter';
import LabelAndCharts from '../generalized/utils/LabelAndCharts';

import OperationalProducts from './utils/OperationalProducts';

// import Sample from './sample.json';
// import OperationalAsset from './utils/OperationalAsset';

const ProductsTab: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState('');
  const [selCountry, setSelCountry] = useState<number | undefined>(undefined);
  const [selState, setSelState] = useState<number | undefined>(undefined);
  const [searchParam, setSearchParams] = useSearchParams();
  const [data, setData] = useState<any[]>([]);

  // const firstYear = yearSelect();

  useEffect(() => {
    window.scrollTo(0, 0);
    const filterCountry = selCountry ?? '';
    const filterState = selState ?? '';
    const filterAll = `/${
      filterCountry
        ? filterState
          ? `${filterCountry}/${filterState}`
          : `${filterCountry}`
        : ''
    }`;

    setIsLoading(true);
    if (selectedYear) {
      Promise.all([
        nzmAPI(
          APITypeEnum.GET_ALL,
          API_ENDPOINT_JSON.NZM.product,
          `${selectedYear}${filterAll}`
        ),
        countryJSON(),
        statesJSON(),
        facilityDetailsAPI(APITypeEnum.GET_ALL, false)
      ])
        .then(([res1]) => {
          setData(res1);
        })
        .catch(() => {
          setData([]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedYear, selCountry, selState]);

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  return (
    <div className="productsMainFlex">
      {searchParam.get('selectedYear') && (
        <YearAndCountryFilter
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          setSelCountry={setSelCountry}
          setSelState={setSelState}
          selState={selState}
          selCountry={selCountry}
          showLeased={false}
          isDisabled={isLoading}
        />
      )}
      {isLoading ? (
        <Loader isHome={true} />
      ) : (
        <>
          {shouldBlockModuleAccess(accessModule.scope3) ? (
            <div style={{marginTop: 20}}>
              <BlockAccessPage
                messageTitle={blockModelMessages.scope.title.genericMessage(
                  '3',
                  'Products'
                )}
                messageDescription={blockModelMessages.scope.description.message(
                  '3'
                )}
                blockedType={blockAccessTypes.PARTIAL}
                modelType={blockModelTypes.SCOPE_TOP}
              />
            </div>
          ) : null}
          <LabelAndCharts title="Operational">
            <OperationalProducts data={data} />
          </LabelAndCharts>
        </>
      )}
    </div>
  );
};

export default ProductsTab;
